<div class="panel">
    <div class="title">
        <div class="header">{{ "dashboard.widgetMarket.title" | transloco }}</div>
        <small class="text-muted">{{ "dashboard.widgetMarket.subtitle" | transloco }}</small>
    </div>
    <div class="search-bar">
        <input
            type="text"
            class="form-control form-control-sm"
            [placeholder]="'dashboard.widgetMarket.searchPlaceholder' | transloco"
            (debounce-input-event)="filter($event)"
            inputTooltip
        />
    </div>
    <div class="available-widgets">
        @for (widget of filteredMarketWidgets; track widget) {
            <div class="widget" draggable="true" (dragstart)="dragStartHandler($event, widget)">
                <div class="widget-image">
                    @if (widget.icon) {
                        <i [class]="widget.icon + ' fa-fw'"></i>
                    }
                </div>
                <div class="widget-info">
                    <div class="widget-title">{{ widget.title | transloco }}</div>
                    <div class="widget-description">{{ widget.description | transloco }}</div>
                </div>
            </div>
        }
    </div>
</div>
